module.exports = __webpack_public_path__ + "static/FuturaBTBook-24c295d2bc67868ea2c367bcf1a3e489.woff";